import { render, staticRenderFns } from "./AS_HomeMobile.vue?vue&type=template&id=010f6848&"
import script from "./AS_HomeMobile.vue?vue&type=script&lang=js&"
export * from "./AS_HomeMobile.vue?vue&type=script&lang=js&"
import style0 from "./AS_HomeMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports